export const shuffle = <T,>(array: T[], inPlace=false) => {
    const temp = inPlace ? array : [...array];

    let i = temp.length;
    while (i != 0) {
        let rand = Math.floor(Math.random() * i);
        i--;
        
        [temp[i], temp[rand]] = [temp[rand], temp[i]];
    }

    return temp;
}